import { useState, useEffect } from "react";
import HeroSection from "./HeroSection";
import Features from "./Features";
import { useLanguage } from "./LanguageContext";
import SmoothScrollLink from "./SmoothScrollLink";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const { t, setLang } = useLanguage();
  const stickyHeaderHeight = 70;

  // 1. SPOSTATA QUI: Definiamo la funzione prima dell'useEffect
  // FUNZIONE DEFINITIVA: Rimuove le classi di Bootstrap all'istante
  const closeMenu = () => {
    const navbarCollapse = document.getElementById("navbarNav");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      // Chiude il menu immediatamente togliendo la classe 'show'
      navbarCollapse.classList.remove("show");
      
      // Ripristina l'icona dell'hamburger (spegne l'eventuale animazione della X)
      const toggler = document.querySelector(".navbar-toggler");
      if (toggler) {
        toggler.classList.add("collapsed");
        toggler.setAttribute("aria-expanded", "false");
      }
    }
  };

  // 2. AGGIORNATO L'USEEFFECT: Richiamiamo closeMenu() allo scroll
  useEffect(() => {
    let lastScrollY = window.scrollY; // Salviamo la posizione iniziale (utile per evitare micro-scatti su iOS)

    const handleScroll = () => {
      setScrolled(window.scrollY > 200);

      // Chiude il menu se l'utente ha scrollato di almeno 10px (evita chiusure accidentali)
      if (Math.abs(window.scrollY - lastScrollY) > 10) {
        closeMenu();
        lastScrollY = window.scrollY;
      }
    };

    // Aggiunto { passive: true } per ottimizzare le performance dello scroll
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`navbar navbar-expand-xl navbar-dark ${
          scrolled ? "scrolled" : "top"
        }`}
      >
        <div className="container">
          <SmoothScrollLink
            to="aboutsection"
            offset={stickyHeaderHeight}
            className="navbar-brand fw-bold d-flex align-items-center"
            style={{ fontSize: "30px", textDecoration: "none", color: "inherit" }}
            onClick={closeMenu} 
          >
            <img
              src="https://res.cloudinary.com/dtem45qog/image/upload/v1748428194/senza_sfondo_tyd5vs.png"
              alt="Logo"
              style={{ height: "60px", marginRight: "10px" }}
            />
            Thirdiograpy
          </SmoothScrollLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="CommentCarousel"
                  offset={stickyHeaderHeight}
                >
                  {t("navDicono")}
                </SmoothScrollLink>
              </li>
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="aboutsection"
                  offset={stickyHeaderHeight}
                >
                  {t("navServizi")}
                </SmoothScrollLink>
              </li>
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="carouselCards"
                  offset={stickyHeaderHeight + 120}
                >
                  {t("navPortfolio")}
                </SmoothScrollLink>
              </li>
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="services"
                  offset={stickyHeaderHeight}
                >
                  {t("navAbout")}
                </SmoothScrollLink>
              </li>
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="faq-section"
                  offset={stickyHeaderHeight}
                >
                  {t("navFAQ")}
                </SmoothScrollLink>
              </li>
              <li className="nav-item" onClick={closeMenu}>
                <SmoothScrollLink
                  className="nav-link"
                  to="ContactDirect"
                  offset={stickyHeaderHeight}
                >
                  {t("navContattami")}
                </SmoothScrollLink>
              </li>
            </ul>

            <div className="d-flex gap-2 align-items-center language-menu">
              <img
                src="https://img.icons8.com/?size=100&id=t3NE3BsOAQwq&format=png&color=000000"
                alt="EN"
                style={{ cursor: "pointer", height: "25px", width: "auto" }}
                onClick={() => { setLang("en"); closeMenu(); }}
              />
              <img
                src="https://img.icons8.com/?size=100&id=JSgvmncLWozY&format=png&color=000000"
                alt="NO"
                style={{ cursor: "pointer", height: "25px", width: "auto" }}
                onClick={() => { setLang("no"); closeMenu(); }}
              />
              <img
                src="https://img.icons8.com/?size=100&id=PW8KZnP7qXzO&format=png&color=000000"
                alt="IT"
                style={{ cursor: "pointer", height: "25px", width: "auto" }}
                onClick={() => { setLang("it"); closeMenu(); }}
              />
            </div>

            <SmoothScrollLink
              to="ContactDirect"
              offset={stickyHeaderHeight}
              className="contact-link-wrapper"
            >
              <button className="scattiamo" onClick={closeMenu}>
                {t("navPulsante")}
              </button>
            </SmoothScrollLink>
          </div>
        </div>
      </nav>

      <header className="header">
        <HeroSection />
        <Features />
      </header>
    </>
  );
};

export default Header;